import { Component, ComponentInterface, h, Prop } from '@stencil/core';

@Component({
  tag: 'signet-table-head',
  styleUrl: 'signet-table.scss',
  shadow: false,
  scoped: false,
})
export class SignetTableHead implements ComponentInterface {
  @Prop() align: 'right' | 'left' = 'left';

  render() {
    const classes = {
      'signet-table-head': true,
      'align-right': this.align === 'right',
      'align-left': this.align === 'left',
    };

    return (
      <h5 class={classes}>
        <slot></slot>
      </h5>
    );
  }
}
